<template lang="">
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 53.66 53.66">
      <g id="Find_a_Vehicle" data-name="Find a Vehicle" transform="translate(-521.399 -307.996)">
        <circle id="Ellipse_1081" data-name="Ellipse 1081" cx="26.33" cy="26.33" r="26.33" transform="translate(521.899 308.496)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
        <g id="Group_8903" data-name="Group 8903" transform="translate(537.194 321.926)">
          <ellipse id="Ellipse_984" data-name="Ellipse 984" cx="8.7" cy="8.7" rx="8.7" ry="8.7" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
          <line id="Line_971" data-name="Line 971" x1="7.385" y1="7.385" transform="translate(14.848 14.848)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    themeColor: {
      type: String,
      default: '#B3B3B3'
    },
    height: {
      type: String,
      default: '53.66px'
    },
    width: {
      type: String,
      default: '53.66px'
    }
  }
}
</script>

<style lang="">

</style>
